import { useToken } from '@chakra-ui/react';

/**
 * recharts takes colour as a plain prop and cannot read a theme token, so the
 * tokens are resolved here. The results are `var(--chakra-colors-…)` strings,
 * which follow the colour mode through CSS without a re-render.
 *
 * Tooltip items and legend labels are drawn in the series colour by default
 * (green is 3.25:1 on white), so both are forced to `text.primary`; the
 * swatch next to each label still identifies the series.
 */
const useChartTheme = (seriesTokens: string[]) => {
  const resolved = useToken('colors', [
    ...seriesTokens,
    'bg.overlay',
    'border.subtle',
    'text.primary',
    'text.secondary',
  ]);
  const series = resolved.slice(0, seriesTokens.length);
  const [tooltipBg, gridColor, textColor, tickColor] = resolved.slice(seriesTokens.length);

  return {
    series,
    grid: { stroke: gridColor },
    tick: { fontSize: 12, fill: tickColor },
    tooltip: {
      itemStyle: { color: textColor },
      contentStyle: {
        backgroundColor: tooltipBg,
        border: `1px solid ${gridColor}`,
        borderRadius: '8px',
        color: textColor,
      },
    },
    legend: {
      formatter: (value: string) => <span style={{ color: textColor }}>{value}</span>,
    },
  };
};

export default useChartTheme;
